const en = {
  translation: {
    cancel: 'Cancel',
    welcome: 'School Menu',
    dashboard: 'Dashboard',
    logout: 'Logout',
    adminDashboard: 'Admin Dashboard',
    viewPublicSite: 'View Public Site',
    allSchools: 'All Schools',
    profile: 'Profile',
    // Profile page translations
    profilePage: {
      title: 'My Profile',
      name: 'Name',
      username: 'Username',
      email: 'Email',
      nameRequired: 'Name is required',
      usernameRequired: 'Username is required',
      usernameInvalid: 'Username can only contain letters, numbers, and underscores',
      usernameHint: 'Use only letters, numbers, and underscores',
      emailRequired: 'Email is required',
      emailInvalid: 'Email is invalid',
      emailInUse: 'Email already in use',
      usernameInUse: 'Username already in use',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      checking: 'Checking...',
      updateSuccess: 'Profile updated successfully',
      updateFailed: 'Failed to update profile',
      changePassword: 'Change Password',
      changePasswordButton: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      currentPasswordRequired: 'Current password is required',
      newPasswordRequired: 'New password is required',
      passwordTooShort: 'Password must be at least 12 characters',
      passwordsDoNotMatch: 'Passwords do not match',
      incorrectPassword: 'Current password is incorrect',
      passwordChangeSuccess: 'Password changed successfully',
      passwordChangeFailed: 'Failed to change password',
      passwordRequirements: 'Minimum 12 characters',
      updatePassword: 'Update Password',
      changing: 'Changing...',
      cancel: 'Cancel'
    },
    // Landing page translations
    landing: {
      hero: {
        title: 'Simplify School Menu Management',
        subtitle: 'Create, translate, and share your school menus in multiple languages with an easy-to-use platform.',
        getStarted: 'Get Started Free',
        goToDashboard: 'Go to Dashboard',
        learnMore: 'Learn More'
      },
      features: {
        title: 'Everything You Need for School Menu Management',
        menuCreation: {
          title: 'Menu Creation',
          description: 'Create weekly or monthly menus with our intuitive editor. Add dishes, courses, and special diet information.'
        },
        translation: {
          title: 'Multilingual Support',
          description: 'Translate your menus to multiple languages. Perfect for international schools and diverse communities.'
        },
        sharing: {
          title: 'Custom Subdomain',
          description: 'Share your menus with a custom subdomain (yourschool.schoolmenus.xyz) for easy access by parents and students.'
        },
        communityAccess: {
          title: 'Easy Community Access',
          description: 'Provide parents and students with simple access to view the latest menus from any device through a dedicated public page.'
        }
      },
      cta: {
        title: 'Ready to simplify your school menu management?',
        subtitle: 'Create an account or log in to start managing your school menus today.',
      },
      footer: {
        about: 'About Us',
        aboutText: 'School Menus is a platform dedicated to making school meal planning and sharing easier for schools worldwide.',
        links: 'Quick Links',
        features: 'Features',
        pricing: 'Pricing',
        faq: 'FAQ',
        legal: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        contact: 'Contact Us',
        email: 'Email: info@schoolmenus.xyz',
        rights: 'All rights reserved.'
      },
      modal: {
        title: 'Thanks for subscribing!',
        message: "We'll keep you updated on the latest features and news.",
        close: 'Close'
      },
      nav: {
        pricing: 'Pricing'
      }
    },
    pricing: {
      title: 'Pricing',
      earlyAccessDescription: 'Congratulations, you are one of the first people to find out about schoolmenus.xyz! We are still under development, which means users may encounter some bugs or performance issues from time to time (hopefully all minor).',
      freeUntilStable: 'In appreciation for bearing with us, schoolmenus.xyz will be free to use until a first stable version is ready. At that point, pricing tiers will be introduced, but any existing users will be rewarded with a free one year subscription so you can continue to use schoolmenus.xyz at least for the rest of the school year without having to worry about starting to pay.'
    },
    common: {
      loading: 'Loading...',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      noData: 'No data available',
      error: 'Error',
      retry: 'Retry',
      new: 'New',
      confirm: 'Confirm',
      close: 'Close',
      add: 'Add',
      remove: 'Remove',
      upload: 'Upload',
      download: 'Download',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      all: 'All',
      none: 'None',
      welcome: 'Welcome',
      logout: 'Logout',
      login: 'Login',
      register: 'Register',
      username: 'Username',
      usernameOrEmail: 'Username or Email',
      password: 'Password',
      email: 'Email',
      name: 'Name',
      description: 'Description',
      success: 'Success',
      warning: 'Warning',
      info: 'Info',
      home: 'Home',
      settings: 'Settings',
      profile: 'Profile',
      dashboard: 'Dashboard',
      summary: 'Summary',
      details: 'Details',
      view: 'View',
      update: 'Update',
      help: 'Helpful Tips',
      'Back to Dashboard': 'Back to Dashboard',
      loadingTranslations: 'Loading translations...',
      saveSelectedTags: 'Save Selected Tags',
      accept: 'Accept'
    },
    navbar: {
      home: 'Home',
      menu: 'Menu',
      admin: 'Admin',
      login: 'Login',
      logout: 'Logout',
      settings: 'Settings',
      createMenu: 'Create Menu',
      dishLibrary: 'Dish Library',
      translations: 'Translations',
      specialNames: 'Special Day Names',
      confirmNavigation: 'Leave this page?',
      unsavedChanges: 'You have unsaved changes. If you leave now, your changes will be lost. Please save your work before leaving or press "Leave" to discard your changes.',
      dashboard: 'Dashboard',
      leave: 'Leave',
      cancel: 'Cancel',
      schoolHomepage: 'School Homepage'
    },
    home: {
      welcome: 'Welcome to School Lunch App',
      viewMenu: 'View Menu',
      aboutSchool: 'About Our School',
      contactUs: 'Contact Us'
    },
    login: 'Login',
    loginPage: {
      email: 'Email',
      password: 'Password',
      loginButton: 'Login',
      loginError: 'Invalid email or password',
      forgotPassword: 'Forgot Password?'
    },
    menu: {
      today: 'Today\'s Menu',
      week: 'Weekly Menu',
      noItems: 'No menu items available',
      loading: 'Loading menu...',
      download: 'Download PDF',
      print: 'Print Menu',
      dashboard: 'Dashboard',
      leave: 'Leave',
      favorites: 'Favorites',
      schoolHomepage: 'School Homepage',
      title: 'School Lunch Menu - {{month}}',
      menuType: 'Menu Type',
      selectMenuType: 'Select Menu Type',
      courses: 'Courses',
      day: 'Day',
      firstCourse: 'First Course',
      secondCourse: 'Second Course',
      dessert: 'Dessert',
      dishNotTranslated: 'Dish not yet translated',
      schoolLunchMenu: 'School Lunch Menu',
      footer: 'Menu is subject to change based on ingredient availability',
      observations: 'Observations',
      noMenu: 'No Menu Available',
      noMenuTypes: 'Loading menu types...',
      loadingMenu: 'Loading menu...',
      noMenuForType: 'This menu type does not have a menu for the current month',
      noMenusAvailable: 'No menus are available for the current month',
      checkingAvailableMenus: 'Checking available menus...',
      'There is no menu available for the current month.': 'There is no menu available for the current month.',
      createThisMenu: 'Create this menu',
      editThisMenu: 'Edit this menu',
      notAvailable: 'Not Available',
      'Month/Year': 'Month/Year',
      'Please select a menu type first': 'Please select a menu type first',
      nutrientDataIncomplete: 'Nutritional information unavailable',
      nutrientDataComplete: 'Nutritional information complete',
      weekNumber: 'Week {{week}}',
      weekShort: 'Week',
      previousWeek: 'Previous Week',
      nextWeek: 'Next Week',
    },
    admin: {
      dashboard: 'Admin Dashboard',
      menus: 'Menus',
      dishes: 'Dishes',
      dish: 'Dish',
      recentMenus: 'Recent Menus',
      month: 'Month',
      actions: 'Actions',
      editTranslations: 'Edit Translations',
      enterTranslation: 'Enter Translation',
      searchReplacement: 'Search for replacement',
      loadingMenu: 'Loading Menu',
      itemsToTranslate: 'Items to translate',
      progress: 'Progress',
      missingLanguages: 'Missing languages',
      skipItem: 'Skip item',
      thisWillOnlyTakeAMoment: 'This will only take a moment',
      noMissingTranslations: 'No missing translations',
      allTranslationsComplete: 'All translations are complete',
      courses: 'Courses',
      menuTypes: 'Menu Types',
      schools: 'Schools',
      users: 'Users',
      settings: 'Settings',
      createMenu: 'Create Menu',
      editMenu: 'Edit Menu',
      createDish: 'Create Dish',
      editDish: 'Edit Dish',
      createCourse: 'Create Course',
      editCourse: 'Edit Course',
      createMenuType: 'Create Menu Type',
      editMenuType: 'Edit Menu Type',
      createSchool: 'Create School',
      editSchool: 'Edit School',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteMenu: 'Delete Menu',
      deleteDish: 'Delete Dish',
      deleteCourse: 'Delete Course',
      deleteMenuType: 'Delete Menu Type',
      deleteSchool: 'Delete School',
      deleteUser: 'Delete User',
      confirmDelete: 'Are you sure you want to delete this {{item}}?',
      confirmDeleteItem: 'Delete {{item}}',
      cancel: 'Cancel',
      delete: 'Delete',
      save: 'Save',
      create: 'Create',
      edit: 'Edit',
      view: 'View',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      ascending: 'Ascending',
      descending: 'Descending',
      noResults: 'No results found',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Info',
      // Menu Management
      menuManagement: 'Menu Management',
      menuName: 'Menu Name',
      menuType: 'Menu Type',
      menuDate: 'Menu Date',
      menuStatus: 'Menu Status',
      menuCreatedAt: 'Created At',
      menuUpdatedAt: 'Updated At',
      menuCreatedBy: 'Created By',
      menuUpdatedBy: 'Updated By',
      menuActions: 'Actions',
      menuEditor: 'Menu Editor',
      menuEditorDesc: 'Create and manage monthly school menus',
      translationEditor: 'Translation Editor',
      translationEditorDesc: 'Manage translations for dishes and other items',
      translationQueue: 'Translation Queue',
      translationQueueDesc: 'Efficiently translate multiple items',
      nutrientQueue: 'Nutrient Queue',
      nutrientQueueDesc: 'Enter nutritional information for dishes',
      tagQueue: 'Tag Queue',
      tagQueueDesc: 'Efficiently manage tag information for multiple dishes',
      settingsDesc: 'Manage school settings, users, and system configurations',
      // Copying Menu
      copyMenu: 'Copy Menu',
      copyFromCurrentToNew: 'Copy this menu to a new menu type for {{month}}',
      copyFromExistingToNew: 'Copy from an existing menu for {{month}}',
      selectTargetMenuType: 'Select target menu type',
      selectSourceMenuType: 'Select source menu type',
      selectMenuType: 'Select a menu type...',
      noAvailableMenuTypes: 'All menu types already have a menu for this month',
      noExistingMenus: 'No menu types have a menu for this month yet',
      errorFetchingMenuTypes: 'Error fetching menu types',
      errorCopyingMenu: 'Error copying menu',
      // Intelligent Substitution Feature
      useIntelligentSubstitution: 'Attempt historical dish substitution',
      intelligentSubstitutionTooltip: 'Uses historical data to intelligently match dishes between menu types based on past usage patterns.',
      // Notifications
      menuCreated: 'Menu created successfully',
      menuUpdated: 'Menu updated successfully',
      menuDeleted: 'Menu deleted successfully',
      specialDayPlaceholder: 'Input special day name',
      dishCreated: 'Dish created successfully',
      dishUpdated: 'Dish updated successfully',
      dishDeleted: 'Dish deleted successfully',
      courseCreated: 'Course created successfully',
      courseUpdated: 'Course updated successfully',
      courseDeleted: 'Course deleted successfully',
      menuTypeCreated: 'Menu Type created successfully',
      menuTypeUpdated: 'Menu Type updated successfully',
      menuTypeDeleted: 'Menu Type deleted successfully',
      schoolCreated: 'School created successfully',
      schoolUpdated: 'School updated successfully',
      schoolDeleted: 'School deleted successfully',
      userCreated: 'User created successfully',
      userUpdated: 'User updated successfully',
      userDeleted: 'User deleted successfully',
      // Day names
      noCourses: 'No Courses Available',
      noCoursesMessage: 'This menu type has no courses attached to it. Please configure courses for this menu type in the Settings page before creating a menu.',
      preview: 'Preview',
      copy: 'Copy',
      // ... existing translations ...
      saveChanges: 'Save Changes',
      copyWeek: {
        success: 'Week copied successfully',
        errorProcessingResponse: 'Error processing response',
        errorInvalidMenuId: 'Invalid menu ID'
      },
      copyDay: {
        success: 'Day copied successfully',
        errorProcessingResponse: 'Error processing response',
        errorInvalidMenuId: 'Invalid menu ID'
      },
      guidanceMenuCreation: {
        title: 'Welcome to Menu Management!',
        description: 'Use this interface to create monthly menus. You can then choose to display these in weekly or monthly format by adjusting the options in the settings page. Click the create button in the top left of the screen to create your first menu, and remember to save it every time you update it or your changes will be lost, by clicking the save button that will appear in this same place on the screen. Once you have created a menu, you can preview it in the preview page and adjust how it will be displayed to your community in the settings page. Happy menu management!'
      },
    },
    dishes: {
      add: 'Add Dish',
      edit: 'Edit Dish',
      name: 'Name',
      description: 'Description',
      type: 'Type',
      tags: 'Tags',
      search: 'Search Dishes'
    },
    calendar: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    general: {
      loading: 'Loading...',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      noData: 'No data available',
      error: 'Error',
      retry: 'Retry',
      checkServerStatus: 'Check Server Status',
      dish: 'Dish',
      specialName: 'Special Day Name',
      close: 'Close',
      accept: 'Accept'
    },
    modal: {
      cancel: 'Cancel',
      delete: 'Delete',
      deletePrompt: 'Are you sure you want to delete {dish}?',
      confirmDelete: 'Confirm Delete',
      changeUntranslatedSpecialName: 'Change untranslated special name',
      changeUntranslatedDish: 'Change untranslated dish',
      untranslatedSpecialName: 'This special name is not yet translated to English. Would you like to change it to something else? Accepting will remove this special name from this day.',
      untranslatedDish: 'This dish is not yet translated to English. Would you like to change it to something else? Accepting will remove this dish from this day.',
      dishInUse: 'This dish is used in {{count}} menu items.',
      specialNameInUse: 'This special name is used in {{count}} days.',
      selectReplacementDish: 'Please select a replacement dish to use in all affected menus.',
      selectReplacementSpecialName: 'Please select a replacement special name to use in all affected days.',
      replacementRequired: 'A replacement is required to delete this item.',
      confirmDeleteDish: 'Are you sure you want to delete this dish? This action cannot be undone.',
      confirmDeleteSpecialName: 'Are you sure you want to delete this special name? This action cannot be undone.',
      deleteAndReplace: 'Delete and Replace',
      deletePermanently: 'Delete Permanently',
      validReplacementSelected: 'Valid replacement selected',
      confirmDeleteMenu: 'Confirm Menu Deletion',
      deleteMenuWarning: 'Are you sure you want to delete this menu?',
      actionCannotBeUndone: 'This action cannot be undone.',
      allMenuDaysWillBeDeleted: 'All days in this menu will be deleted.',
      allMenuItemsWillBeDeleted: 'All menu items in this menu will be deleted.',
      deleteMenu: 'Delete Menu'
    },
    languages: {
      en: 'English',
      ca: 'Catalan',
      es: 'Spanish'
    },
    settings: {
      title: 'Settings',
      manageUsers: 'Manage Users',
      users: 'Users',
      menuTypes: 'Menu Types',
      courses: 'Courses',
      nutrients: 'Nutrients',
      schoolInfo: 'School Information',
      webhooks: 'Webhooks',
      addUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userName: 'Name',
      userEmail: 'Email',
      userUsername: 'Username',
      userRoles: 'Roles',
      userRole: 'Role',
      userPassword: 'Password',
      userSave: 'Save User',
      confirmDeleteUser: 'Are you sure you want to delete this user?',
      userDeleted: 'User deleted successfully',
      errorDeletingUser: 'Error deleting user',
      userSaved: 'User saved successfully',
      errorSavingUser: 'Error saving user',

      // User management
      roles: 'Roles',
      inviteUser: 'Invite User',
      invite: 'Invite',
      inviting: 'Inviting...',
      emailRequired: 'Email is required',
      roleRequired: 'At least one role must be selected',
      userNotExist: 'This user does not exist. They need to create an account first',
      userInvited: 'User successfully invited to the school',
      errorInvitingUser: 'Error inviting user',
      superadmin: 'Superadmin',
      admin: 'Admin',
      editor: 'Editor',
      viewer: 'Viewer',
      userRolesUpdated: 'User roles updated successfully',
      errorUpdatingRoles: 'Error updating user roles',
      remove: 'Remove',
      userRemoved: 'User removed from school successfully',
      errorRemovingUser: 'Error removing user from school',
      enterEmail: 'Enter email address',
      selectRoles: 'Select Roles',
      updateRoles: 'Update Roles',
      superadminOnly: 'Superadmin only',
      cannotRemoveAdmin: 'Only superadmins can remove admin or superadmin users',
      restrictedAccess: 'Restricted access',
      noUsers: 'No users found',
      errorFetchingUsers: 'Error fetching users',
      roleExplanation: 'Role Permissions',
      superadminDesc: 'Full access to this school, can assign any roles including admin and superadmin',
      adminDesc: 'Full access to this school, cannot assign admin/superadmin or remove them',
      editorDesc: 'Can edit menus and content but not users',
      viewerDesc: 'Read-only access',

      schoolName: 'School Name',
      subdomain: 'Subdomain',
      homepageUrl: 'Homepage URL',
      showNutrients: 'Show Nutrient Information',
      defaultLanguage: 'Default Language',
      saveBasicInfo: 'Save Basic Info',
      schoolInfoSaved: 'School information saved successfully',
      errorSavingSchoolInfo: 'Error saving school information',
      logo: 'Logo',
      uploadLogo: 'Upload Logo',
      logoUploaded: 'Logo uploaded successfully',
      errorFetching: 'Error fetching settings',
      subdomainLocked: 'Contact support to change subdomain',
      schoolColors: 'School Colors',
      primaryBgColor: 'Primary Background Color',
      primaryTextColor: 'Primary Text Color',
      secondaryBgColor: 'Secondary Background Color',
      secondaryTextColor: 'Secondary Text Color',
      
      // Menu Type specific translations
      menuType: 'Menu Type',
      menuTypeVisibility: 'Menu Type Visibility',
      showMenuTypePublicly: 'Show this menu type in public menu',
      visibilityExplanation: 'When enabled, this menu type will be shown in the public menu viewer',
      menuTypeOptions: 'Display Options',
      showNutrientsForMenuType: 'Show nutrients information for this menu type',
      showTagsForMenuType: 'Show tags information for this menu type',
      nutrientTagExplanation: 'These settings control whether nutrient and tag information is displayed for this menu type, in addition to the school-level settings.',
      menuTypeSaved: 'Menu type saved successfully',
      menuTypeDeleted: 'Menu type deleted successfully',
      errorSavingMenuType: 'Error saving menu type',
      errorDeletingMenuType: 'Error deleting menu type',
      menuTypeInUseExplanation: 'You must change the menu type in these menus before you can delete it',
      noNutrients: 'No Nutrients',
      noTags: 'No Tags',
      noTranslationAvailable: 'No translation available',
      enterTranslation: 'Enter translation',
      requiredTranslation: 'Required translation',
      defaultLanguageField: 'Default language field',
      usingFallbackTranslation: 'Using fallback translation',
      
      // Delete confirmations
      deleteMenuTypeConfirmation: 'Delete Menu Type',
      deleteCourseConfirmation: 'Delete Course',
      confirmDeleteMenuType: 'Are you sure you want to delete menu type "{name}"?',
      confirmDeleteCourse: 'Are you sure you want to delete course "{name}"?',
      cannotDeleteMenuTypeInUse: 'This menu type is used in {count} menus and cannot be deleted.',
      cannotDeleteCourseInUse: 'This course is used in {count} menu items and cannot be deleted.',
      courseInUseExplanation: 'You must remove or replace this course in all menus before you can delete it.',
      usingFallbackTranslation: 'Using fallback translation',
      
      // Subdomain-related translations
      checkingAvailability: 'Checking availability...',
      subdomainEmpty: 'Subdomain cannot be empty',
      subdomainInvalidFormat: 'Invalid format. Use lowercase letters, numbers, and hyphens. Cannot start or end with a hyphen.',
      subdomainCheckError: 'Error checking subdomain availability',
      waitForSubdomainCheck: 'Please wait while we check the subdomain availability',
      subdomainNotAvailable: 'This subdomain is not available',
      subdomainChanged: 'Subdomain updated successfully! DNS changes may take time to propagate.',
      subdomainCooldown: 'Subdomain Change Cooldown Period',
      cooldownWillEndOn: 'You can change your subdomain again on {{date}} at {{time}}.',
      subdomainChangeMessage: 'Your subdomain was changed within the last 14 days. You can change it again in 14 days.',
      dnsNoteHeading: 'Important note about subdomain changes:',
      dnsNote1: 'It may take up to 30 minutes for DNS changes to propagate across the internet.',
      dnsNote2: 'During this time, some users may still access your site through the previous subdomain.',
      dnsNote3: 'Your previous subdomain will continue to redirect to your new subdomain for 7 days.',
      
      languages: 'Languages',
      manageLanguages: 'Manage Languages',
      availableLanguages: 'Available languages',
      languagesSaved: 'Languages saved successfully',
      selectDefaultLanguage: 'Select a default language',
      
      // Navigation and common UI elements
      welcome: 'School Menu',
      dashboard: 'Dashboard',
      logout: 'Logout',
      schoolHomepage: 'School Website',
      
      // User roles for display
      admin: 'Administrator',
      editor: 'Editor',
      viewer: 'Viewer',
      
      noLanguagesSelected: 'No languages selected',
      languagesDescription: 'Select which languages your school will use',
      menuTypesDescription: 'Menu types define the structure of your menus',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      actions: 'Actions',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      addNewUser: 'Add New User',
      addNewMenuType: 'Add New Menu Type',
      addNewCourse: 'Add New Course',
      saveChanges: 'Save Changes',
      saveCustomContent: 'Save Custom Content',
      saveBranding: 'Save Branding',
      saveDisplayOptions: 'Save Display Options',
      schoolInformation: 'School Information',
      contactEmail: 'Contact Email',
      contactPhone: 'Contact Phone',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      manageMenuTypes: 'Manage Menu Types',
      manageCourses: 'Manage Courses',
      menuTypeVisibility: 'Menu Type Visibility',
      showMenuTypePublicly: 'Show this menu type in public menu',
      visibilityExplanation: 'When enabled, this menu type will be shown in the public menu viewer',
      hidden: 'Hidden',
      
      // Missing translation keys
      translations: 'Translations',
      defaultLanguageField: 'Default language - required',
      requiredTranslation: 'Required - enter translation',
      languagesExplanation: 'Select which languages you want to activate for your school. Only selected languages will be shown to users.',
      defaultLanguageExplanation: 'Select the default language for your school. This language will be shown initially to all users who have not selected a language preference.',
      languageWarning: 'Note: Disabling a language will hide it from the language switcher, but existing translations will be preserved.',
      basicInformation: 'Basic Information',
      customContent: 'School Description',
      customContentPlaceholder: 'Enter a description of your school to display on the homepage',
      customContentSaved: 'Custom content saved successfully.',
      errorSavingCustomContent: 'Error saving custom content',
      disclaimerText: 'Disclaimer Text',
      disclaimerTextPlaceholder: 'Enter disclaimer text for menu images...',
      saveDisclaimerText: 'Save Disclaimer Text',
      disclaimerTextSaved: 'Disclaimer text saved successfully',
      errorSavingDisclaimerText: 'Error saving disclaimer text',
      includeCustomContentInImage: 'Include custom content in menu images',
      includeCustomContentInImageExplanation: 'Control whether custom content appears in daily menu images downloaded from the menu preview page.',
      branding: 'Branding',
      schoolLogo: 'School Logo',
      logoNote: 'Recommended size: 200x200px. Maximum size: 2MB. Accepted formats: JPG, PNG, GIF, SVG.',
      
      // Menu Type Management
      defaultMenuType: 'Default Menu Type',
      defaultMenuTypeExplanation: 'Select which menu type will be shown by default in the menu viewer',
      selectDefaultMenuType: 'Select a default menu type',
      updateDefaultMenuType: 'Update Default',
      defaultMenuTypeUpdated: 'Default menu type updated successfully',
      errorUpdatingDefaultMenuType: 'Error updating default menu type',
      coursesForMenuType: 'Courses for this Menu Type',
      loadingCourses: 'Loading courses...',
      noCoursesForMenuType: 'No courses assigned to this menu type',
      addCourseToMenuType: 'Add Course to Menu Type',
      noAvailableCourses: 'No courses available to add',
      selectCourse: 'Select a course',
      moveUp: 'Move Up',
      moveDown: 'Move Down',
      removeCourse: 'Remove Course',
      courseAddedToMenuType: 'Course added to menu type successfully',
      courseRemovedFromMenuType: 'Course removed from menu type successfully',
      errorAddingCourseToMenuType: 'Error adding course to menu type',
      errorRemovingCourseFromMenuType: 'Error removing course from menu type',
      course: 'Course',
      deleteCourseConfirmation: 'Delete Course',
      confirmDeleteCourse: 'Are you sure you want to delete course "{name}"?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      defaultLanguageRequired: 'A default language must be selected',
      defaultLanguageMustBeSelected: 'The default language must be one of the selected languages',
      errorSavingDefaultLanguage: 'Error saving default language',
      requiredLanguage: 'Required language',
      noMenuTypesAvailable: 'No menu types available. Create a menu type first.',
      noTranslationsAvailable: 'No translations available',
      noCourses: 'No courses available',
      atLeastOneLanguage: 'Please select at least one language',
      defaultMustBeSelected: 'The default language must be included in the selected languages',
      errorReorderingCourse: 'Error reordering course',
      courseReordered: 'Course reordered successfully',
      errorFetchingMenuTypeCourses: 'Error fetching courses for menu type',
      errorUpdatingCourse: 'Error updating course',
      
      // Month Navigation Settings
      monthNavigation: {
        title: 'Public Navigation Settings',
        description: 'Allow public users to navigate between periods (months or weeks) in the menu viewer.',
        enable: 'Enable Public Navigation',
        monthsBack: 'Periods Back Allowed',
        monthsAhead: 'Periods Ahead Allowed',
        daysAfterStart: 'Days Allowed to Go Back (After Period Start)',
        daysBeforeEnd: 'Days Allowed to Go Forward (Before Period End)',
        saveSettings: 'Save Navigation Settings',
        invalidNumber: 'Please enter a valid number',
        mustBePositive: 'Value must be zero or positive',
        tooManyMonths: 'Value cannot exceed {{max}} periods',
        tooManyDays: 'Value cannot exceed {{max}} days',
        maxMonthsRange: 'Maximum {{max}} periods',
        maxDaysRange: 'Maximum {{max}} days',
        // New keys for the display type toggle
        displayType: 'Display Type',
        weekly: 'Weekly',
        monthly: 'Monthly',
        monthlyDescription: 'The public menu will display a full month at a time.',
        weeklyDescription: 'The public menu will display a week at a time.'
      },
      
      // Confirmation Modals
      confirmationModal: {
        title: 'Confirm Changes',
        saveChanges: 'Save Changes',
        discardChanges: 'Discard Changes',
        unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to leave this page?',
        leavePage: 'Leave Page',
        stayOnPage: 'Stay on Page'
      },
      enterTranslation: 'Enter translation here...',
      save: 'Save',
      errorFetchingTranslations: 'Error fetching translations.',
      errorUpdatingMenuType: 'Error updating menu type.',
      confirmDeleteUser: 'Confirm User Deletion',
      manageUsers: 'Manage Users',
      menuTypeUpdated: 'Menu type updated successfully.',
      courseUpdated: 'Course updated successfully.',
      deleteCourse: 'Delete Course',
      customContentSaved: 'Custom content saved successfully.',
      tags: 'Tags',
      general: 'General',
      appearance: 'Appearance',
      account: 'Account',
      notifications: 'Notifications',
      languageSettings: 'Language Settings',
      addLanguage: 'Add Language',
      languageName: 'Language Name',
      languageCode: 'Language Code',
      languageNativeName: 'Native Name',
      editLanguage: 'Edit Language',
      deleteLanguage: 'Delete Language',
      deleteLanguageConfirmation: 'Are you sure you want to delete this language? All associated translations will be lost.',
      confirmDelete: 'Confirm Delete',
      languageInUse: 'This language is currently in use for menus or dishes and cannot be deleted.',
      languageAdded: 'Language added successfully.',
      languageUpdated: 'Language updated successfully.',
      languageDeleted: 'Language deleted successfully.',
      failedToAddLanguage: 'Failed to add language.',
      failedToUpdateLanguage: 'Failed to update language.',
      failedToDeleteLanguage: 'Failed to delete language.',
      billing: 'Billing',
      languageInUse: 'This language is currently in use for menus or dishes and cannot be deleted.',
      languageAdded: 'Language added successfully.',
      languageUpdated: 'Language updated successfully.',
      languageDeleted: 'Language deleted successfully.',
      failedToAddLanguage: 'Failed to add language.',
      failedToUpdateLanguage: 'Failed to update language.',
      failedToDeleteLanguage: 'Failed to delete language.',
      menuTypes: 'Menu Types',
      menuType: 'Menu Type',
      addMenuType: 'Add New Menu Type',
      editMenuType: 'Edit Menu Type',
    },
    upload: {
      fileTooLarge: 'File is too large. Maximum size is {{maxSize}}MB.',
      invalidFileType: 'Invalid file type. Please upload an image file.',
      errorReadingFile: 'Error reading file. Please try again.',
      dragAndDrop: 'Drag and drop file here',
      or: 'or',
      browse: 'browse files',
      maxSizeNote: 'Max. file size: {{maxSize}}MB',
      acceptedFormatsNote: 'Accepted formats'
    },
    preview: 'Preview',
    remove: 'Remove',
    // Language names
    languageNames: {
      en: 'English',
      ca: 'Catalan',
      es: 'Spanish',
      fr: 'French'
    },
    translations: {
      bulkTranslations: 'Bulk Translations',
      individualTranslations: 'Individual Translations',
      step1: 'Step 1: Export Pending Translations',
      step2: 'Step 2: Complete Translations in Excel',
      step3: 'Step 3: Validate and Import',
      exportDescription: 'Download an Excel file with all items that need translation. Complete the missing translations in the file.',
      uploadDescription: 'Upload your completed Excel file with translations.',
      validateDescription: 'Check your translations and import them to the database.',
      selectFile: 'Select Translation File',
      exportTranslations: 'Export Translations',
      exportPendingTranslations: 'Export pending translations',
      exportAllTranslations: 'Export all translations',
      exporting: 'Exporting...',
      validating: 'Validating...',
      validateAndImport: 'Validate & Import',
      confirmImport: 'Confirm Import',
      fileValid: 'File Validation Successful',
      readyToImport: 'The translations file is valid and ready to be imported.',
      importing: 'Importing...',
      validationResults: 'Validation Results',
      importResults: 'Import Results',
      validationSummary: 'Summary of the translations validation',
      importSummary: 'Summary of the translations import operation',
      totalItems: 'Total Items',
      totalTranslations: 'Total Translations',
      itemsProcessed: 'Items Processed',
      translationsCreated: 'Translations Created',
      translationsUpdated: 'Translations Updated',
      warningsFound: 'There {{count, plural, one {is # warning} other {are # warnings}}}',
      rowError: 'Row {{row}}',
      moreErrors: 'and {{count}} more errors',
      importSuccess: 'Import Successful',
      exportError: 'Error exporting translations: {{error}}',
      importError: 'Error importing translations: {{error}}',
      validationError: 'Validation Error',
      validationErrorDetails: 'The uploaded file could not be validated due to the following issue:',
      fileEmpty: 'The file appears to be empty or has an invalid format.',
      requiredColumnsNotFound: 'Required columns (ID, Type, Reference Name) were not found in the file.',
      noLanguageColumns: 'No valid language columns were found in the file.',
      wrongFileFormat: 'The file might be in the wrong format. Please use the template from the "Export Translations" step.',
      fileStructureExample: 'The file should have language columns first (like "English", "Spanish", "Catalan"), followed by "ID", "Type", and "Reference Name" columns.',
      tryExportFirst: 'Try exporting a template file first, then add your translations to it rather than creating a file from scratch.',
      toBeCreated: 'To Be Created',
      toBeUpdated: 'To Be Updated',
      detailedChanges: 'Detailed Changes',
      name: 'Name',
      type: 'Type',
      language: 'Language',
      from: 'From',
      to: 'To',
      notSet: 'Not set',
      showingFirstN: 'Showing first {{count}} items',
      newTranslationsHeading: 'Items with New Translations',
      updatedTranslationsHeading: 'Items with Updated Translations',
      unchangedTranslationsHeading: 'Items with Unchanged Translations',
      item: 'Item'
    },
    fileUploader: {
      dragDrop: 'Drag and drop your file here',
      or: 'or',
      browse: 'browse files',
      acceptedTypes: 'Accepted file types',
      maxSize: 'Maximum size',
      fileSelected: 'File selected. Click to replace.',
      clear: 'Clear',
      invalidType: 'Invalid file type. Please select one of: {{acceptedTypes}}',
      fileTooLarge: 'File is too large. Maximum size is {{maxSize}} MB',
      clickToReplace: 'Click or drag to replace',
      currentFile: 'Current file',
      fileError: 'There was an error with the file'
    },
    loginToSchool: 'Login to {{schoolName}}',
    loginToAccount: 'Login to your account',
    mainDomainLoginDescription: 'Login to access all your schools',
    schoolSelectorTitle: 'Your Schools',
    schoolSelectorDescription: 'Select a school to manage its menus and settings',
    createNewSchool: 'Create New School',
    accessAdmin: 'Access Admin',
    delete: 'Delete',
    noSchoolsFound: 'You do not have access to any schools yet.',
    deleteSchool: 'Delete School',
    deleteSchoolConfirmation: 'Are you sure you want to delete',
    deleteSchoolWarning: 'This action cannot be undone.',
    deleting: 'Deleting...',
    creating: 'Creating...',
    createSchool: 'Create School',
    schoolName: 'School Name',
    subdomain: 'Subdomain',
    homepageUrl: 'School Website URL',
    subdomainHelp: 'Only lowercase letters, numbers, and hyphens',
    
    // Pagination specific translations
    pagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      results: 'results',
      previous: 'Previous',
      next: 'Next'
    },
    // Errors (Add new section if it doesn't exist)
    errors: {
      fetchNutrientDetailsFailed: 'Failed to load nutrient details.',
      selectWeekFirst: 'Please select a week first',
      selectDayFirst: 'Please select a day first',
      selectDaysFirst: 'Please select at least one day first',
      failedToLoadMenuTypes: 'Failed to load menu types',
      failedToCopyWeek: 'Failed to copy week',
      failedToCopyDay: 'Failed to copy day(s)',
      // Add other generic or specific error keys here as needed
    },
    // Excel Export Headers
    excelHeaders: {
      referenceName: 'Reference Name'
    },
    // Nutrient Tab Specific
    nutrientutils: {
      nutrients: 'Nutrients',
      nutrientDisplaySettings: 'Nutrient Display Settings',
      nutritionalInformationExplanation: 'Choose whether nutritional information for each daily menu should be displayed in the menu viewer. If any of the daily menu\'s dishes are missing nutritional information, a message will be displayed instead saying nutritional information is not available.',
      showNutrients: 'Show nutritional information in menu viewer',
      addNewNutrient: 'Add New Nutrient',
      errorLoadingNutrients: 'Error loading nutrients. Please try again later.',
      noNutrientsYet: 'No nutrients have been created yet.',
      disabled: 'Hidden',
      enabledNutrient: 'Show this nutrient in the menu viewer',
      editNutrient: 'Edit Nutrient',
      deleteNutrient: 'Delete Nutrient',
      deleteNutrientConfirmation: 'Are you sure you want to delete this nutrient? This action cannot be undone.',
      nutrientUpdated: 'Nutrient updated successfully',
      errorUpdatingNutrient: 'Error updating nutrient.',
      nutrientDeleted: 'Nutrient deleted successfully',
      errorDeletingNutrient: 'Error deleting nutrient.',
      errorCreatingNutrient: 'Error creating nutrient. Please try again.',
      bulkNutrientsTitle: 'Bulk Nutrient Operations',
      step1: 'Step 1: Export Template',
      exportDescription: 'Download an Excel file containing dishes and enabled nutrients. You can export only dishes missing nutrients or all dishes.',
      exportMissingButton: 'Export Missing',
      exportAllButton: 'Export All',
      exportError: 'Error exporting nutrient data: {{error}}',
      step2: 'Step 2: Upload Completed File',
      importDescription: 'Fill in the nutrient values in the exported Excel file and upload it here.',
      selectFileButton: 'Select Nutrient File (.xlsx)',
      validationError: 'File Validation Error',
      validationErrorDetails: 'The uploaded file could not be validated due to the following issue:',
      wrongFileFormat: 'The file might be in the wrong format or structure. Please use the template from the "Export" step.',
      fileStructureExample: 'The file should have columns "Dish ID", "Reference Name", followed by columns for each enabled nutrient (e.g., "Energy (kcal)", "Protein (g)").',
      tryExportFirst: 'Try exporting a template file first, then add your nutrient values to it.',
      checkUnits: 'Ensure nutrient values match the expected units (if specified in the header).',
      step3: 'Step 3: Validate & Import',
      validateDescription: 'Check your uploaded file for errors before importing the data.',
      validateImportButton: 'Validate File',
      itemType: 'Dishes',
      confirmImportButton: 'Import Nutrients',
      importSuccessMessage: 'Nutrient import successful',
      validationModalTitle: 'Nutrient Import Validation',
      fileEmpty: 'The file appears to be empty or has an invalid format.',
      missingNutrientColumns: 'Missing required nutrient columns: {{message}}',
      invalidNumericValue: 'Invalid numeric value found. Values must be non-negative numbers.',
      invalidDishId: 'Invalid Dish ID found: {{message}}',
      importResults: 'Import Results',
      importSummary: 'Summary of the nutrient import operation',
      validationFailedSummary: 'The file contains errors and cannot be imported.',
      validationSuccessSummary: 'Review the changes below before confirming the import.',
      fileName: 'File Name',
      dishesToUpdate: 'Dishes to Update',
      totalValuesToUpdate: 'Total Values to Update',
      errorsFound: '{{count}} Error(s) Found',
      rowError: 'Row {{row}}',
      updatedItemsHeading: 'Nutrient Values to be Updated',
      dishIdHeader: 'Dish ID',
      noValue: 'No Value',
      fileValid: 'File Validated Successfully',
      readyToImport: 'The file is ready to be imported.',
      newValuesHeading: 'Dishes with New Nutrient Values ({{count}})',
      changedValuesHeading: 'Dishes with Changed Nutrient Values ({{count}})',
      dishesWithUpdates: 'Dishes With Updates',
      newValuesCount: 'New Values',
      changedValuesCount: 'Changed Values',
    },
    tags: {
      displaySettings: 'Tag Display Settings',
      showInMenu: 'Show tag information in public menu',
      showInMenuHelp: 'When enabled, tag icons will appear under dishes in the public menu with a legend explaining each tag.',
      existing: 'Existing Tags',
      createNew: 'Create New Tag',
      translations: 'Translations',
      logo: 'Tag Logo',
      uploadLogo: 'Upload logo (optional)',
      logoRequirements: 'Recommended size: 64x64px. Max size: 2MB. Supported formats: JPG, PNG, GIF, SVG, WebP',
      create: 'Create Tag',
      creating: 'Creating...',
      editTag: 'Edit Tag',
      deleteConfirmation: 'Delete Tag',
      deleteWarning: 'Are you sure you want to delete this tag? This action cannot be undone.',
      noLogo: 'No logo',
      noTranslation: 'No translation available',
      noLanguages: 'No languages selected for this school. Please add languages in the Languages tab.',
      defaultLanguageRequired: 'Translation in default language is required',
      translationRequired: 'At least one translation is required',
      fetchError: 'Failed to load tags',
      createSuccess: 'Tag created successfully',
      createError: 'Failed to create tag',
      updateSuccess: 'Tag updated successfully',
      updateError: 'Failed to update tag',
      deleteSuccess: 'Tag deleted successfully',
      deleteError: 'Failed to delete tag',
      settingUpdateSuccess: 'Tag display setting updated',
      settingUpdateError: 'Failed to update tag display setting',
      noSchoolId: 'School ID is missing',
      loadError: 'Error loading tags',
      empty: 'No tags have been created yet',
      fetchDetailError: 'Failed to fetch tag details',
      legend: 'Legend',
      noTagsInDish: 'No Tags in this Dish',
      loading: 'Loading tags...',
      notConfiguredWarning: 'No tags configured. Add tags in the Settings page first.',
      queueTitle: 'Tag Queue',
      saved: 'Tags saved successfully',
      saveError: 'Failed to save tags',
      selectAtLeastOneOrConfirmNone: 'Please select at least one tag, or use the \'Confirm: No Tags\' button.',
      dishes: 'Dishes',
      noSearchResults: 'No dishes match your search',
      noDishesNeedTags: 'No dishes need tag information',
      unsavedChanges: 'Unsaved changes',
      pendingChanges: 'Pending',
      assignFor: 'Assign tags for',
      confirmNoTags: 'Confirm: No Tags',
      selectTags: 'Select tags in this dish',
      noTagsConfigured: 'No tags configured for this school yet. Please add tags in the Settings page first.',
      selectDish: 'Select a dish to assign tags',
      allDishesComplete: 'All dishes have tag information. Great job!'
    },
    copyWeek: {
      title: 'Copy Week',
      targetMenuType: 'Target Menu Type',
      targetMonth: 'Target Month',
      targetWeek: 'Target Week',
      selectMenuType: 'Select Menu Type',
      selectWeek: 'Select Week',
      daysInTargetMonth: 'Days in target month:',
      weekLabel: 'Week {{weekNumber}}: {{dateRange}}',
      copy: 'Copy',
      confirmOverwrite: 'Confirm Overwrite',
      confirmOverwriteMessage: 'A menu already exists for the target month and menu type. Do you want to overwrite the menu items for the selected days?'
    },
    copyDay: {
      title: 'Copy Day',
      targetMenuType: 'Target Menu Type',
      targetMonth: 'Target Month',
      targetDay: 'Target Day',
      targetDays: 'Target Days',
      selectMenuType: 'Select Menu Type',
      selectDay: 'Select Day',
      selectMultipleDays: 'Select one or more days',
      selectedDay: 'Selected day:',
      selectedDays: 'Selected days:',
      sourceDay: 'Source day:',
      copy: 'Copy',
      confirmOverwrite: 'Confirm Overwrite',
      confirmOverwriteMessage: 'A menu already exists for the target month and menu type. Do you want to overwrite the menu items for the selected day?',
      confirmOverwriteMultipleMessage: 'A menu already exists for the target month and menu type. Do you want to overwrite the menu items for the {{count}} selected days?',
      success: 'Day copied successfully',
      multiSuccess: 'Days copied successfully',
      errorProcessingResponse: 'Error processing response',
      errorInvalidMenuId: 'Invalid menu ID'
    },
    errors: {
      selectWeekFirst: 'Please select a week first',
      selectDayFirst: 'Please select a day first',
      selectDaysFirst: 'Please select at least one day first',
      failedToLoadMenuTypes: 'Failed to load menu types',
      failedToCopyWeek: 'Failed to copy week',
      failedToCopyDay: 'Failed to copy day(s)'
    },
    'Special Names': 'Special Names',
    'Select an item from the list to edit its translations.': 'Select an item from the list to edit its translations.',
    ' Nutrient values can also be edited here.': ' Nutrient values can also be edited here.',
    'Nutrient Values': 'Nutrient Values',
    'No nutrients configured for this school.': 'No nutrients configured for this school.',
    Tags: 'Tags',
    'No Tags in this Dish': 'No Tags in this Dish',
    usernameOrEmail: 'Username or Email',
    password: 'Password',
    loggingIn: 'Logging in...',
    loginSuccess: 'Login successful!',
  },
  queue: {
    individualInput: 'Individual Input',
    bulkImportExport: 'Bulk Import/Export',
    dishesMissingNutrients: 'Dishes Missing Nutrients',
    missing: 'missing',
    editNutrientsFor: 'Edit Nutrients For',
    missingNutrients: 'Missing Nutrients',
    nutrientValuesSaved: 'Nutrient values saved successfully!',
    errorSavingNutrients: 'Error saving nutrient values',
    enterValue: 'Enter value',
    skipItem: 'Skip Item',
    deleteDish: 'Delete Dish',
    saveAndNext: 'Save & Next',
    selectDishToEnterNutrients: 'Select a dish from the list to enter nutrient values',
    nutrientQueueCompleteMessage: 'All dishes have nutritional values entered.',
    nutrientQueueCompleteTitle: 'Nutrient Queue Complete!',
    errorLoadingNutrientQueue: 'Error loading nutrient queue.',
  },
};

export default en;
